import React from "react";
import HeaderComponent from "../WebSite/Header/HeaderComponent";
import FooterComponent from "../WebSite/Footer/FooterComponent";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import "./FieldSupportService.css";
import FieldSupportServiceSection1 from "./FieldSupportServiceSection1";
import FArmerCTATab from "../FarmerCTATab/FArmerCTATab";

// Exporting the FieldSupportService functional component
export default function FieldSupportService() {
  return (
    <>
      {/* Header section */}
      <HeaderComponent />

      {/* Updates banner for Field Support Service */}
      <UpdatesBanner
        className="fieldSupportServiceBanner"
        bannerText={["Field Support Service"]}
      />

      {/* Main content section */}
      <div>
        {/* Section showing Field Support Service */}
        <FieldSupportServiceSection1 />

        {/* Farmer Call-To-Action Tab */}
        <FArmerCTATab />
      </div>

      {/* Footer section */}
      <FooterComponent />
    </>
  );
}
